import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { BankAccountPage as BankAccountPageView } from "@/components/BankAccountPage";

export function BankAccountPage() {
  const { modules, hasModule } = useModules();
  const { accountId } = useParams<{ accountId: string }>();
  const navigate = useNavigate();
  if (modules === null) return null;
  if (!hasModule("banking") || !accountId) return <Navigate to="/" replace />;
  return <BankAccountPageView accountId={accountId} onBack={() => navigate("/organisation/bank-connections")} />;
}
